export enum SocketNames {
  MainInput = 'MainInput',
  MainOutput = 'MainOutput',
  StartOutput = 'StartOutput',
  Default = 'DefaultOutput',
  Inactive = 'InactiveOutput',
  Fail = 'FailOutput',
  Success = 'SuccessOutput',
}

export type SocketsActionsTypes = {
  createOutput: (output?: number, type?: SocketNames) => number
  deleteOutput: (id: number) => void
  checkOutput: (output: number) => boolean
  switchIsMoved: (id: number, state: boolean) => void
}

export const SELF_NODE_ITEM = 'SELF_NODE_ITEM'
